/**
 * Личная цена ПРО на месяц для витрины (рф): у кого есть право на ДВОЙНУЮ
 * ВЫГОДУ или зачёт (backend/first_month_credit.py) — его цена из /auth/me,
 * иначе null (карточка как была). doubleBenefit — результат useDoubleBenefit:
 * на ру акции нет, и он там всегда «none».
 */
export function personalMonthPrice(doubleBenefit, term, proIsOwned) {
  if (proIsOwned || !doubleBenefit?.eligible || term?.key !== 'month') return null;
  const price = Number(doubleBenefit.price);
  return Number.isFinite(price) && price > 0 ? price : null;
}
